// extracted by mini-css-extract-plugin
module.exports = {"reportDivider":"ReportTableListADA_reportDivider__-SuHS"};